import { useToast } from '@chakra-ui/react';
import FileSaver from 'file-saver';
import { useLazyExportClusterQuery } from 'core/API/clusterApi';
import { useGetCompanyInfoSelector } from 'core/redux/selectors/authSelectors';
import { useTranslation } from 'helpers/languages/translations';
import { EXCEL_FILE_TYPE } from 'shared/const';

export const useHandleExcelExport = () => {
    const translate = useTranslation();
    const toast = useToast();

    const [exportClusterQuery] = useLazyExportClusterQuery();
    const companyInfo = useGetCompanyInfoSelector();

    return async (page: 'cluster' | 'shop-cluster' | 'product-cluster', retailers?: (number | string)[]) => {
        try {
            const { data: res, isError: isExportError } = await exportClusterQuery({
                type: page,
                retailers,
            });

            if (isExportError || !res) throw new Error(translate(`${page}.export.error`) as string);

            const blob = new Blob([res], {
                type: EXCEL_FILE_TYPE,
            });

            FileSaver.saveAs(blob, translate(`${page}.export.fileName`, { name: companyInfo!.name_id }) as string);
        } catch (error) {
            toast({
                title: (error as Error).message,
                status: 'error',
                isClosable: true,
            });
        }
    };
};
